// extracted by mini-css-extract-plugin
export var checkbox = "_6n-0";
export var circle = "_6n-3";
export var horizontalContainer = "_6n-7";
export var sm = "_6n-5";
export var switch0 = "_6n-2";
export var switchDisabled = "_6n-8";
export var switchEnabled = "_6n-1";
export var textSwitchContainer = "_6n-9";
export var textSwitchOption = "_6n-a";
export var textSwitchOptionSelected = "_6n-b";
export var verticalContainer = "_6n-6";
export var xs = "_6n-4";